module.exports = __webpack_public_path__ + "assets/camera.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/camera.svg
// module id = 800
// module chunks = 0